<main
  [class.loading-screen]="loading"
  class="mat-elevation-z2 am">
  <mat-nav-list>
    <div
      class="empty"
      *ngIf="!repeatableCases.length">
      <p class="am apts">
        <T str="No repeatable cases found"></T>
      </p>
    </div>
    <ng-container *ngFor="let repeatableCase of repeatableCases; last as last">
      <mat-list-item
        lines="3"
        (click)="click(repeatableCase)">
        <span matListItemTitle>{{ repeatableCase.case?.name }}</span>

        <span matListItemLine>{{ repeatableCase.case?.Object?.name }}</span>

        <span matListItemLine>
          <ng-container *ngIf="repeatableCase.interval === 'daily'">
            <T str="Daily - "></T>
          </ng-container>
          <ng-container *ngIf="repeatableCase.interval === 'weekly'">
            <T str="Weekly - "></T>
            {{ repeatableCase.case.from | dater | date: 'EEEE' }}
          </ng-container>
          <ng-container *ngIf="repeatableCase.interval === 'monthly'">
            <T str="Monthly - "></T>
            {{ repeatableCase.case.from | dater | date: 'dd' }}
          </ng-container>
          <ng-container *ngIf="repeatableCase.interval === 'quarterly'">
            <T str="Quarterly - "></T>
          </ng-container>
          <ng-container *ngIf="repeatableCase.interval === 'yearly'">
            <T str="Yearly - "></T>
            {{ repeatableCase.case.from | dater | date: 'dd.LL' }}
          </ng-container>
          <ng-container *ngIf="repeatableCase.endDate">
            <T str="Active until"></T>
            {{ repeatableCase.endDate | dater | date: 'shortDate' }}
          </ng-container>
        </span>
      </mat-list-item>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>
  </mat-nav-list>
</main>
